import { routes } from '@/features/v2/constants/routes';

export const core = {
  cards: [
    {
      id: 1,
      title: 'Slots',
      description: 'Card 1 description',
      image: '/img/v2/casino/slots.webp',
      url: `${routes.CASINO}/slots`,
    },
    {
      id: 2,
      title: 'Cartas',
      description: 'Card 2 description',
      image: '/img/v2/casino/cartas.webp',
      url: `${routes.CASINO}/cards`,
    },
    // {
    //   id: 3,
    //   title: 'Crash',
    //   description: 'Card 3 description',
    //   image: '/img/v2/casino/crash.webp',
    //   url: `${routes.CASINO}?collections=crash&view=games`,
    // },
    {
      id: 4,
      title: 'Ruleta',
      description: 'Card 4 description',
      image: '/img/v2/casino/ruleta.webp',
      url: `${routes.CASINO}/roulette`,
    },
    // {
    //   id: 5,
    //   title: 'Dados',
    //   description: 'Card 2 description',
    //   image: '/img/v2/casino/dados.webp',
    //   url: `${routes.CASINO}?collections=craps&view=games`,
    // },
    {
      id: 6,
      title: 'En vivo',
      description: 'Card 1 description',
      image: '/img/v2/casino/live.webp',
      url: `${routes.CASINO}/live`,
    },
  ],
  seasonalCards: [
    {
      id: 10,
      title: 'Halloween',
      description: 'Juegos de Halloween',
      image: '/img/v2/casino/especial/hallowen.webp',
      url: `${routes.CASINO}?theme=halloween&view=games`,
      theme: 'halloween',
    },
    {
      id: 11,
      title: 'Navidad',
      description: 'Juegos de Navidad',
      image: '/img/v2/casino/especial/navidad.webp',
      url: `${routes.CASINO}?theme=navidad&view=games`,
      theme: 'navidad',
    },
    {
      id: 12,
      title: 'San Patricio',
      description: 'Juegos de San Patricio',
      image: '/img/v2/casino/especial/sanPatricio.webp',
      url: `${routes.CASINO}?theme=sanPatricio&view=games`,
      theme: 'sanPatricio',
    },
    {
      id: 13,
      title: 'Pascua',
      description: 'Juegos de Pascua',
      image: '/img/v2/casino/especial/pascua.webp',
      url: `${routes.CASINO}?theme=pascua&view=games`,
      theme: 'pascua',
    },
    {
      id: 14,
      title: 'San Valentín',
      description: 'Juegos de San Valentín',
      image: '/img/v2/casino/especial/sanValentin.webp',
      url: `${routes.CASINO}?theme=sanValentin&view=games`,
      theme: 'sanValentin',
    },
  ],
  tabs: [
    {
      id: 'lobby',
      label: 'Lobby',
    },
    {
      id: 'para-ti',
      label: 'Para tí',
    },
    {
      id: 'recomendaciones',
      label: 'Recomendaciones',
    },
    // {
    //   id: 'nuevos-juegos',
    //   label: 'Nuevos juegos',
    // },
    {
      id: 'juegos',
      label: 'Juegos',
    },
  ],
};
